var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_630_29439)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 1.33203H3.33333C2.59333 1.33203 2 1.93203 2 2.66536V11.9987C2 12.732 2.6 13.332 3.33333 13.332H6L7.52667 14.8587C7.78667 15.1187 8.20667 15.1187 8.46667 14.8587L10 13.332H12.6667C13.4 13.332 14 12.732 14 11.9987V2.66536C14 1.93203 13.4 1.33203 12.6667 1.33203ZM8 3.53203C8.99333 3.53203 9.8 4.3387 9.8 5.33203C9.8 6.32536 8.99333 7.13203 8 7.13203C7.00667 7.13203 6.2 6.32536 6.2 5.33203C6.2 4.3387 7.00667 3.53203 8 3.53203ZM12 10.6654H4V10.0654C4 8.73203 6.66667 7.9987 8 7.9987C9.33333 7.9987 12 8.73203 12 10.0654V10.6654Z",
    fill: "#1E4133"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_630_29439"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.e74902a92bf541ff9d4fe2e4d388f640.svg";
export { ForwardRef as ReactComponent };